import React from "react";
import { BIRTHDAY_REWARD_PATH } from "utils/constants/paths";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";

const BirthdayReward = Loadable(React.lazy(() => import("./View")));

export const BirthdayRewardRoute: IRouteItem = {
  path: BIRTHDAY_REWARD_PATH,
  element: React.createElement(BirthdayReward),
  name: "Birthday Reward",
  accessKeys: ["SuperAdmin", "Admin", "ContentManager"],
};
